<template>
  <div>
    <div class="sleepOcclusion">
      <div class="sleepOcclusion__option">
        <div class="occlusionOption">
          <div class="occlusionOption__box" style="width:300px;">
            <h4>Landmark</h4>
            <div class="occlusionOption__box--font">
              <input type="radio" style="cursor:pointer;" name="landmark" id="person" value="person" v-model="PropsLandmark"/>
              <label for="person" style="cursor:pointer;" > &nbsp; person </label>
            </div>
            <div class="occlusionOption__box--font">
              <input type="radio" style="cursor:pointer;" name="landmark" id="bed" value="bed" v-model="PropsLandmark"/>
              <label for="bed" style="cursor:pointer;" > &nbsp; bed </label>
            </div>
            <div class="occlusionOption__box--font">
              <input type="radio" style="cursor:pointer;" name="landmark" id="chair" value="chair" v-model="PropsLandmark"/>
              <label for="chair" style="cursor:pointer;"> &nbsp; chair </label>
            </div>
            <div class="occlusionOption__box--font">
              <input type="radio" style="cursor:pointer;" name="landmark" id="dog" value="dog" v-model="PropsLandmark"/>
              <label for="dog" style="cursor:pointer;"> &nbsp; dog </label>
            </div>
            <div class="occlusionOption__box--font">
              <input type="radio" style="cursor:pointer;" name="landmark" id="cat" value="cat" v-model="PropsLandmark"/>
              <label for="cat" style="cursor:pointer;"> &nbsp; cat </label>
            </div>
          </div>
          <div class="occlusionOption__box">
            <h4> Marked</h4>
            <div :key="item.index" v-for="item in feedbackStoreRectData" :style="{color:classDecideColor[item.class]}">
              <button @click="deleteStoredRectData(item)">x</button>
              {{item.class}} [{{item.bbox[0]}},{{item.bbox[1]}}] -> [{{item.bbox[2]}},{{item.bbox[3]}}]
            </div>
          </div>
        </div>
      </div>

      <div class="sleepOcclusion__right">
        <div class="sleepOcclusion__right--image">
          <labeledImage
            :PropsBatchType="PropsBatchType"
            :PropsBatchDate="PropsBatchDate"
            :PropsImgName="PropsImgName"
            :PropsLevelTwo="PropsLevelTwo"
            :PropsLandmark="PropsLandmark"
            :PropsRectDataFromApi="PropsRectDataFromApi"
            :PropsSpaceKeydown="PropsSpaceKeydown"
            @feedbackStoreRectData="getbackFromChild"
            @feedbackSpaceKeyDown="getBackSpaceKeyDown"
          >
          </labeledImage>
        </div>
        <div class="label-fun">
          <div class="sleepOcclusion__right--control">
            <div v-if="is_uncertain">
              <button class="btn btn-primary mg-r-ten btn-fashion" @click.prevent="uncertain()">
              cancel Uncertain</button>
            </div>
            <div v-else>
              <button class="btn btn-secondary mg-r-ten btn-fashion" @click.prevent="uncertain()">
                Uncertain</button>
            </div>
            <div v-if="is_skip">
              <button class="btn btn-primary mg-r-ten btn-fashion" @click.prevent="skip()">
                cancelSkip
              </button>
            </div>
            <div v-else>
              <button class="btn btn-secondary mg-r-ten btn-fashion" @click.prevent="skip()">
                Skip
              </button>
            </div>
          </div>
          <button
            class="btn btn-secondary mg-r-ten btn-fashion"
            @click.prevent="backward()"
            :disabled="current===1"
          >
            <i class="fas fa-backward"></i>
          </button>
          <button
            class="btn btn-secondary mg-r-ten btn-fashion"
            :disabled="total===current"
            @click.prevent="forward()"
          >
            <i class="fas fa-forward"></i>
          </button>
          <button class="btn btn-primary btn-fashion" @click.prevent="storeAndNext()">
              Store &amp; Next</button>
          <div style="margin:5px; text-align:right; font-size:18px;">{{current}} / {{total}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/api/client'
import labeledImage from '@/components/labeledImage/labeledImage.vue';

export default {
  components: { labeledImage },
  data() {
    return {
      PropsBatchType: 'live_main',
      PropsBatchDate: null,
      PropsImgName: null,
      PropsLevelTwo: true,
      PropsLandmark: 'person',
      PropsRectDataFromApi: null,
      PropsSpaceKeydown: false,
      current: 0,
      total: 0,
      labeledImgName: [], // 儲存已產生過的img
      feedbackStoreRectData: null,
      is_skip: null,
      is_uncertain: false,
      classDecideColor: {
        person: '#24ceb9',
        bed: 'green',
        chair: 'red',
        cat: 'cornflowerblue',
        dog: 'khaki',
      },
    };
  },
  methods: {
    getMeta() {
      const vm = this;
      client.get(`/meta/live_main/${vm.labeledImgName[vm.current - 1]}`).then((res) => {
        console.log('get');
        console.log(res);
        vm.is_skip = res.is_skip;
        vm.PropsBatchDate = res.batch_date;
        vm.PropsImgName = res.name;
        if (res.is_uncertain) {
          vm.is_uncertain = res.is_uncertain;
        } else {
          vm.is_uncertain = false;
        }
        if (res.label_bboxes) {
          vm.PropsRectDataFromApi = res.label_bboxes;
        } else if (res.result_bboxes) {
          vm.PropsRectDataFromApi = res.result_bboxes;
        }
      });
    },
    nextLabel() {
      const vm = this;
      if (vm.current < vm.total) {
        vm.current += 1;
        vm.getMeta();
      } else {
        client.get('/meta/live_main/to_label').then((res) => {
          console.log('get');
          console.log(res);
          vm.is_skip = res.is_skip;
          vm.PropsBatchDate = res.batch_date;
          vm.PropsImgName = res.name;
          if (res.label_bboxes) {
            vm.PropsRectDataFromApi = res.label_bboxes;
          } else if (res.result_bboxes) {
            vm.PropsRectDataFromApi = res.result_bboxes;
          }
          if (res.is_uncertain) {
            vm.is_uncertain = res.is_uncertain;
          } else {
            vm.is_uncertain = false;
          }
          vm.labeledImgName.push(vm.PropsImgName);
          vm.current += 1;
          vm.total += 1;
        });
      }
    },
    storeAndNext() {
      const vm = this;
      const body = {
        name: vm.PropsImgName,
        label_alert_type: vm.alert,
        is_skip: vm.is_skip,
        is_uncertain: false,
        label_bboxes: vm.feedbackStoreRectData,
      };
      client.post('/meta/live_main', null, body).then((res) => {
        console.log('Next post');
        console.log(res);
        vm.nextLabel();
      });
    },
    skip() {
      const vm = this;
      const body = {
        name: vm.PropsImgName,
        is_skip: !vm.is_skip,
        is_uncertain: false,
        label_bboxes: vm.feedbackStoreRectData,
      };
      client.post('/meta/live_main', null, body).then((res) => {
        console.log('skip post');
        console.log(res);
        vm.nextLabel();
      });
    },
    uncertain() {
      const vm = this;
      const body = {
        name: vm.PropsImgName,
        is_uncertain: !vm.is_uncertain,
        is_skip: false,
        label_bboxes: vm.feedbackStoreRectData,
      };
      client.post('/meta/live_main', null, body).then((res) => {
        console.log('uncertain post');
        console.log(res);
        vm.nextLabel();
      });
    },
    backward() {
      const vm = this;
      vm.current -= 1;
      vm.PropsRectDataFromApi = [];
      vm.getMeta();
    },
    forward() {
      const vm = this;
      vm.current += 1;
      vm.PropsRectDataFromApi = [];
      vm.getMeta();
    },
    getbackFromChild(data) {
      this.feedbackStoreRectData = data;
    },
    deleteStoredRectData(item) {
      const vm = this;
      vm.feedbackStoreRectData.splice(vm.feedbackStoreRectData.indexOf(item), 1);
      vm.PropsRectDataFromApi = vm.feedbackStoreRectData;
    },
    getBackSpaceKeyDown(data) {
      this.PropsSpaceKeydown = data;
      console.log(this.PropsSpaceKeydown);
    },
  },
  mounted() {
    const vm = this;
    vm.PropsDe
    vm.nextLabel();
    // eslint-disable-next-line
    document.onkeydown = function (e) {
      const keycode = {
        ArrowUp: () => {
          vm.skip();
        },
        Enter: () => {
          vm.storeAndNext();
          e.preventDefault();
        },
        ArrowLeft: () => {
          if (vm.current !== 1) {
            vm.backward();
          }
        },
        ArrowRight: () => {
          if (vm.total !== vm.current) {
            vm.forward();
          }
        },
        KeyD: () => {
          if (vm.PropsLandmark === 'person') {
            vm.PropsLandmark = 'bed';
          } else if (vm.PropsLandmark === 'bed') {
            vm.PropsLandmark = 'chair';
          } else if (vm.PropsLandmark === 'chair') {
            vm.PropsLandmark = 'dog';
          } else if (vm.PropsLandmark === 'dog') {
            vm.PropsLandmark = 'cat';
          } else if (vm.PropsLandmark === 'cat') {
            vm.PropsLandmark = 'person';
          }
        },
        KeyE: () => {
          if (vm.PropsLandmark === 'person') {
            vm.PropsLandmark = 'cat';
          } else if (vm.PropsLandmark === 'cat') {
            vm.PropsLandmark = 'dog';
          } else if (vm.PropsLandmark === 'dog') {
            vm.PropsLandmark = 'chair';
          } else if (vm.PropsLandmark === 'chair') {
            vm.PropsLandmark = 'bed';
          } else if (vm.PropsLandmark === 'bed') {
            vm.PropsLandmark = 'person';
          } 
        },
        KeyC: () => {
          if (!vm.PropsSpaceKeydown) {
            console.log('spcae key down');
            vm.PropsSpaceKeydown = true;
          }
        },
      };
      keycode[e.code]();
    };
  },
};
</script>
